/**
 * Uygulama yapılandırması.
 * Ortam değişkenleri Vite `import.meta.env` üzerinden okunur.
 */
export const appConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://findthereal.cgo.com.tr/api/v1',
  clientVersion: import.meta.env.VITE_CLIENT_VERSION ?? '0.1.0',
  defaultLocale: 'tr' as const,
  fallbackLocale: 'en' as const,
  targetFps: 60,
  gameWidth: 1080,
  gameHeight: 1920,
} as const;

export type AppConfig = typeof appConfig;
